import React, { useState, useEffect, useRef } from "react";
import {
  CreateMetaData,
  CreateNewParamenter,
  DeleteNewMeta,
  MetaDataList,
  getParameterDetails,
  FetchDataTypes,
  MetaDataDetails,
  ExportParameters,
  GetMetaDataByID,
  GetExportParameters,
  updateMetaData,
  updateParameterData,
  updateExportParameterData,
  deleteParameter,
  deleteExportParameter,
} from "../../api/api";
import Cookies from "js-cookie";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import clsx from "clsx";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { ProcessList } from "./ProcessList";
import { Button } from "../../components/Button/Button";
import _ from "lodash";

const CreateMetaDataForm = (handleNext, handleCancel, onNext) => {
  const [data, setData] = useState({
    name: "",
    label: "",
    description: "",
    schemaName: "",
    executionMethod: "",
    spName: "",
    resourceUrl: "",
    httpMethod: "",
    returnType: "",
    submitButtonText: "",
    cancelButtonText: "",
    allowExecute: false,
    allowExcelExport: false,
    allowPdfExport: false,
    allowCsvExport: false,
    active: false,
  });

  const [errors, setErrors] = useState({
    name: "",
    executionMethod: "",
    spName: "",
    resourceUrl: "",
    httpMethod: "",
    returnType: "",
  });
  const emptyParamData = {
    //id: "",
    name: "",
    parameterType: "",
    dbType: "",
    type: null,
    position: 0,
    isNullable: false,
    defaultValue: "",
    length: 0,
    precision: 0,
    scale: 0,
    inputType: "",
    label: "",
    placeHolder: "",
    tooltip: "",
    InputDataSource: [],
    options: [],
    active: false,
    pattern: "",
  };

  const emptyExportData = {
    //id: "",
    name: "",
    type: "",
    headerText: "",
    position: 0,
    allowExcelExport: false,
    allowPdfExport: false,
    allowCsvExport: false,
  };

  const [showForm, setShowForm] = useState(false);
  const [first, setfirst] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [openInputData, setOpenInputData] = useState(true);
  const [isTabOpen, setIsTabOpen] = useState(false);
  const [metaData, setMetadata] = useState("");
  const [newParamdata, setNewParamdata] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isResponse, setIsResponse] = useState(true);
  const [validatemeta, setValidatemeta] = useState(false);
  const [metaList, setMetaList] = useState("");
  const [paramDetails, setParamDetails] = useState("");
  const [selectType, setSelectType] = useState("");
  const [inputdataSource, setInputdataSource] = useState("");
  const [requestTypeList, setRequestTypeList] = useState("");
  const [requestTypeSelected, setRequestTypeSelected] = useState("");
  const [requestTypeListSelectedItems, setRequestTypeListSelectedItems] =
    useState("");
  const [getRequestTypeKey, setGetRequestTypeKey] = useState("");
  const [requestTypeValue, setRequestTypeValue] = useState("");
  const [requestTypeLabel, setRequestTypeLabel] = useState("");
  const [compareParameterData, setCompareParameterData] = useState(null);
  const [compareExportParameterData, setCompareExportParameterData] =
    useState(null);
  const [editMetadataID, setGetEditMetadataID] = useState(null);
  const [selectedMetaData, setSelectedMetaData] = useState(null);
  const [selectedParameter, setSelectedParameter] = useState(null);
  const [abc, setAbc] = useState(null);
  const [successMsg, setSuccessMsg] = useState([]);
  const [errorMsg, setErrorMsg] = useState([]);
  const childRef = useRef(null);

  const updateData = (event) => {
    let value;
    if (event.target.name === "allowExecute") {
      value = event.target.value === "true";
    } else if (event.target.name === "allowExcelExport") {
      value = event.target.value === "true";
    } else if (event.target.name === "allowPdfExport") {
      value = event.target.value === "true";
    } else if (event.target.name === "allowCsvExport") {
      value = event.target.value === "true";
    } else if (event.target.name === "active") {
      value = event.target.value === "true";
    } else {
      value = event.target.value;
    }
    setData({
      ...data,
      [event.target.name]: value,
    });
  };

  const handleSubmitMetaData = (e) => {
    e.preventDefault();
    setValidatemeta(true);

    setIsTabOpen(true);
    let isError = false;

    // if (data.name === "") {
    //   isError = true;
    //   errors.name = "Name is required.";
    // }
    // if (data.executionMethod === "") {
    //   isError = true;
    //   errors.executionMethod = "Execution Method is required.";
    // }
    // if (data.spName === "") {
    //   isError = true;
    //   errors.spName = "spName is required.";
    // }
    // if (data.resourceUrl === "") {
    //   isError = true;
    //   errors.resourceUrl = "resourceUrl is required.";
    // }
    // if (data.httpMethod === "") {
    //   isError = true;
    //   errors.httpMethod = "httpMethod is required.";
    // }
    // if (data.returnType === "") {
    //   isError = true;
    //   errors.returnType = "returnType is required.";
    // }

    setShowForm(true);
    setTabIndex(1);
    setIsTabOpen(true);
  };

  // parameters store and handle add and remove
  const [forms, setForms] = useState([emptyParamData]);

  const handleAdd = () => {
    setForms([...forms, emptyParamData]);
  };

  const removeFormFields = (index) => {
    let data = [...forms];
    data.splice(index, 1);
    setForms(data);
  };

  // export parameter store and handle add, remove
  const [exportforms, setExportForms] = useState([emptyExportData]);
  const handleAddExport = () => {
    setExportForms([...exportforms, emptyExportData]);
  };
  const removeFormExportFields = (index) => {
    let data = [...exportforms];
    data.splice(index, 1);
    setExportForms(data);
  };

  // options add and remove code
  const [optionsList, setOptionsList] = useState([{ label: "", value: "" }]);
  const addOptionsFields = () => {
    let object = {
      label: "",
      value: "",
    };
    setOptionsList([...optionsList, object]);
  };
  const removeFields = (index) => {
    let data = [...optionsList];
    data.splice(index, 1);
    setOptionsList(data);
  };

  const handleSubmitParaData = (e, index) => {
    e.preventDefault();

    let isErrorParam = false;

    if (data.type === "") {
      isErrorParam = true;
      errors.type = "type is required.";
    }
    if (data.position === "") {
      isErrorParam = true;
      errors.position = "Position is required.";
    }
    if (data.length === "") {
      isErrorParam = true;
      errors.length = "length is required.";
    }
    if (data.precision === "") {
      isErrorParam = true;
      errors.precision = "precision is required.";
    }
    if (data.scale === "") {
      isErrorParam = true;
      errors.scale = "scale is required.";
    }
    if (data.inputType === "") {
      isErrorParam = true;
      errors.inputType = "inputType is required.";
    }

    if (data.returnType === "dataprocess" && editMetadataID === null) {
      setIsSubmit(true);
      try {
        CreateMetaData(data, Cookies.get("newJwt"))
          .then((response) => response?.json())
          .then((response) => {
            setMetadata(response);
            if (response.errors) {
              setErrorMsg((prevResponses) => [
                ...prevResponses,
                "Error Creating Process !",
              ]);
            }
          })
          .catch((error) => {
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error Creating Process !",
            ]);
          });
      } catch (error) {
        setErrorMsg((prevResponses) => [
          ...prevResponses,
          "Error Creating Process !",
        ]);
      }
    } else {
      setTabIndex(2);
      setShowForm(true);
      setIsTabOpen(true);
    }

    if (editMetadataID !== null && data.returnType === "dataprocess") {
      const isDataUpdated = !_.isEqual(data, selectedMetaData);
      if (isDataUpdated) {
        updateMetaData(editMetadataID, data, Cookies.get("newJwt"))
          .then((response) => {
            if (response.ok) {
              return response.text();
            } else {
              throw new Error("Error updating metadata");
            }
          })
          .then((response) => {
            setMetadata(response);
            setMetadataForm(false);
            //refetch();
            setSuccessMsg((prevResponses) => [
              ...prevResponses,
              "Metadata updated successfully!",
            ]);
            setMetadataForm(false);
            //setExportForms([emptyExportData]);
            setForms([emptyParamData]);
          })
          .catch((error) => {
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error Creating Process !",
            ]);
          });
      }

      // Edit parameter data
      const differencesParaMeter = _.differenceWith(
        JSON.parse(JSON.stringify(forms)),
        JSON.parse(JSON.stringify(compareParameterData)),
        _.isEqual
      );

      if (differencesParaMeter.length > 0) {
        differencesParaMeter.forEach((modifiedParam) => {
          const modifiedParamId = modifiedParam.id; // Assuming each parameter has an 'id' property

          // Send a PUT request to update the modified parameter
          if(modifiedParamId){
            updateParameterData(
              modifiedParamId,
              modifiedParam,
              Cookies.get("newJwt")
            )
              .then((response) => {
                if (response.ok) {
                  return response.text();
                } else {
                  throw new Error("Error updating metadata");
                }
              })
              .then((response) => {
                setMetadata(response);
                setSuccessMsg((prevResponses) => [
                  ...prevResponses,
                  "Parameter updated successfully",
                ]);
                setMetadataForm(false);
                //setExportForms([emptyExportData]);
                setForms([emptyParamData]);
              })
              .catch((error) => {
                setErrorMsg((prevResponses) => [
                  ...prevResponses,
                  "Error Updating Parameter!",
                ]);
              });
          }
          
        });
      }

      // Edit parameters end
      // Add New Parameter
      const addedParams = forms.reduce((added, element) => {
        if (!compareParameterData.find((item) => item.id === element.id)) {
          added.push(element);
        }
        return added;
      }, []);
      if (addedParams.length > 0) {
        // Perform the necessary action for added parameters
        CreateNewParamenter(editMetadataID, addedParams, Cookies.get("newJwt"))
          .then((response) => {
            // Handle the response if needed
            setSuccessMsg((prevResponses) => [
              ...prevResponses,
              "Parameters added successfully!",
            ]);
          })
          .catch((error) => {
            // Handle the error if needed
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error adding parameters!",
            ]);
          });
      }

       // Delete a parameter
       const deleteParameters = async () => {
        const deletedIds = compareParameterData.reduce((deleted, element) => {
          if (!forms.find((item) => item.id === element.id)) {
            deleted.push(element.id);
          }
          return deleted;
        }, []);

        if (deletedIds.length > 0) {
          try {
            const deleteRequests = deletedIds.map((id) => {
              return deleteParameter(id, Cookies.get("newJwt"));
            });

            for (const request of deleteRequests) {
              const response = await request;

              if (response.ok) {
                // Handle successful deletion
                // ...
              } else {
                throw new Error("Error deleting parameters");
              }
            }

            // Update metadata and display success message

            setMetadataForm(false);
            setSuccessMsg((prevResponses) => [
              ...prevResponses,
              "Parameters deleted successfully",
            ]);
          } catch (error) {
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error deleting parameters!",
            ]);
          }
        }
      };

      deleteParameters();

      // delete parameters end
    }
  };

  const handleExportParaData = (e) => {
    e.preventDefault();
    if (editMetadataID === null) {
      try {
        CreateMetaData(data, Cookies.get("newJwt"))
          .then((response) => response?.json())
          .then((response) => {
            setMetadata(response);
            if (response.errors) {
              setErrorMsg((prevResponses) => [
                ...prevResponses,
                "Error Creating Process !",
              ]);
            }
          })
          .catch((error) => {
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error Creating Process !",
            ]);
          });
      } catch (error) {
        setErrorMsg((prevResponses) => [
          ...prevResponses,
          "Error Creating Process !",
        ]);
      }
    }

    //  update edited data
    if (editMetadataID && data.returnType !== "dataprocess") {
      const isDataUpdated = !_.isEqual(data, selectedMetaData);
      if (isDataUpdated) {
        updateMetaData(editMetadataID, data, Cookies.get("newJwt"))
          .then((response) => {
            if (response.ok) {
              return response.text();
            } else {
              throw new Error("Error updating metadata");
            }
          })
          .then((response) => {
            setMetadata(response);
            setMetadataForm(false);
            //refetch();
            setSuccessMsg((prevResponses) => [
              ...prevResponses,
              "Metadata updated successfully!",
            ]);
            setMetadataForm(false);
            //setExportForms([emptyExportData]);
            setForms([emptyParamData]);
          })
          .catch((error) => {
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error Creating Process !",
            ]);
          });
      }

      // Edit parameter data
      const differencesParaMeter = _.differenceWith(
        JSON.parse(JSON.stringify(forms)),
        JSON.parse(JSON.stringify(compareParameterData)),
        _.isEqual
      );

      if (differencesParaMeter.length > 0 && differencesParaMeter) {
        differencesParaMeter.forEach((modifiedParam) => {
          const modifiedParamId = modifiedParam.id; // Assuming each parameter has an 'id' property
          // Send a PUT request to update the modified parameter
          if(modifiedParamId){
            updateParameterData(
              modifiedParamId,
              modifiedParam,
              Cookies.get("newJwt")
            )
              .then((response) => {
                if (response.ok) {
                  return response.text();
                } else {
                  throw new Error("Error updating metadata");
                }
              })
              .then((response) => {
                setMetadata(response);
                setSuccessMsg((prevResponses) => [
                  ...prevResponses,
                  "Parameter updated successfully",
                ]);
                setMetadataForm(false);
                //setExportForms([emptyExportData]);
                setForms([emptyParamData]);
              })
              .catch((error) => {
                setErrorMsg((prevResponses) => [
                  ...prevResponses,
                  "Error Updating Parameter!",
                ]);
              });
          }
          
        });
      }

      // Edit parameters end

      // Add New Parameter
      const addedParams = forms.reduce((added, element) => {
        if (!compareParameterData.find((item) => item.id === element.id)) {
          added.push(element);
        }
        return added;
      }, []);
      if (addedParams.length > 0) {
        // Perform the necessary action for added parameters
        CreateNewParamenter(editMetadataID, addedParams, Cookies.get("newJwt"))
          .then((response) => {
            // Handle the response if needed
            setSuccessMsg((prevResponses) => [
              ...prevResponses,
              "Parameters added successfully!",
            ]);
          })
          .catch((error) => {
            // Handle the error if needed
            console.log(error);
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error adding parameters!",
            ]);
          });
      }

      // Add New Parameter End

      // Delete a parameter
      const deleteParameters = async () => {
        const deletedIds = compareParameterData.reduce((deleted, element) => {
          if (!forms.find((item) => item.id === element.id)) {
            deleted.push(element.id);
          }
          return deleted;
        }, []);

        if (deletedIds.length > 0) {
          try {
            const deleteRequests = deletedIds.map((id) => {
              return deleteParameter(id, Cookies.get("newJwt"));
            });

            for (const request of deleteRequests) {
              const response = await request;

              if (response.ok) {
                // Handle successful deletion
                // ...
              } else {
                throw new Error("Error deleting parameters");
              }
            }

            // Update metadata and display success message

            setMetadataForm(false);
            setSuccessMsg((prevResponses) => [
              ...prevResponses,
              "Parameters deleted successfully",
            ]);
          } catch (error) {
            console.log(error);
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error deleting parameters!",
            ]);
          }
        }
      };

      deleteParameters();

      // delete parameters end

      const addedExportParams = exportforms.reduce((added, element) => {
        if (
          !compareExportParameterData.find((item) => item.id === element.id)
        ) {
          added.push(element);
        }
        return added;
      }, []);

      if (Array.isArray(addedExportParams) && addedExportParams.length > 0) {
        ExportParameters(
          addedExportParams,
          editMetadataID,
          Cookies.get("newJwt")
        )
          .then((response) => {
            // Handle the response if needed
            setSuccessMsg((prevResponses) => [
              ...prevResponses,
              "Export Parameters added successfully!",
            ]);
          })
          .catch((error) => {
            // Handle the error if needed
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error adding Export parameters!",
            ]);
          });

      } else {
        console.log("The array does not contain objects");
      }

      const differencesExportParaMeter = _.differenceWith(
        JSON.parse(JSON.stringify(exportforms)),
        JSON.parse(JSON.stringify(compareExportParameterData)),
        _.isEqual
      );
      if (differencesExportParaMeter?.length > 0) {
        differencesExportParaMeter.forEach((modifiedParam) => {
          const modifiedParamId = modifiedParam.id; // Assuming each parameter has an 'id' property
          // Send a PUT request to update the modified parameter
          if(modifiedParamId){
            updateExportParameterData (
              modifiedParamId,
              modifiedParam,
              Cookies.get("newJwt")
            )
              .then((response) => {
                if (response.ok) {
                  return response.text();
                } else {
                  throw new Error("Error updating metadata");
                }
              })
              .then((response) => {
                setSuccessMsg((prevResponses) => [
                  ...prevResponses,
                  "Export Parameter updated successfully!",
                ]);
                setMetadataForm(false);
                //setExportForms([emptyExportData]);
                setForms([emptyParamData]);
              })
              .catch((error) => {
                console.log(error);
                setErrorMsg((prevResponses) => [
                  ...prevResponses,
                  "Error Updating Export Parameter!",
                ]);
              });
          }
          
        });
      }
      // ADD Export Parameter End

      // Delete Export Parameter
      const deleteExportParameters = async () => {
        const deletedExportIds = compareExportParameterData.reduce(
          (deleted, element) => {
            if (!exportforms.find((item) => item.id === element.id)) {
              deleted.push(element.id);
            }
            return deleted;
          },
          []
        );

        if (deletedExportIds.length > 0) {
          try {
            const deleteRequests = deletedExportIds.map((id) => {
              return deleteExportParameter(id, Cookies.get("newJwt"));
            });

            for (const request of deleteRequests) {
              const response = await request;

              if (response.ok) {
                // Handle successful deletion
                // ...
              } else {
                throw new Error("Error deleting export parameters");
              }
            }

            // Update metadata form and display success message
            setMetadataForm(false);
            setSuccessMsg((prevResponses) => [
              ...prevResponses,
              "Export parameters deleted successfully!",
            ]);
          } catch (error) {
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error deleting export parameters!",
            ]);
          }
        }
      };
      deleteExportParameters();
    }
  };

  useEffect(() => {
    if (metaData.id !== undefined && metaData.id && editMetadataID === null) {
      CreateNewParamenter(metaData.id, forms, Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setNewParamdata(response);
          response.errors
            ? setErrorMsg((prevResponses) => [
                ...prevResponses,
                "Error Creating Process !",
              ])
            : setSuccessMsg((prevResponses) => [
                ...prevResponses,
                "Process Created Successfully",
              ]);
          setMetadataForm(false);
          //setExportForms([emptyExportData]);
          setForms([emptyParamData]);

          //childRef.current.refetch();

          if (response.errors) {
            DeleteNewMeta(metaData.id, Cookies.get("newJwt"))
              .then((response) => response?.json())
              .then((response) => {
                setErrorMsg((prevResponses) => [
                  ...prevResponses,
                  "Error Creating Process !",
                ]);
              });
          }
        })
        .catch((error) => {
          DeleteNewMeta(metaData.id, Cookies.get("newJwt"))
            .then((response) => response?.json())
            .then((response) => {
              setIsResponse(false);
              setErrorMsg((prevResponses) => [
                ...prevResponses,
                "Error Creating Process !",
              ]);
            });
        });
    }
  }, [metaData]);

  // export parameter post data
  useEffect(() => {
    if (metaData?.id && editMetadataID === null && data.returnType !== "dataprocess") {
      const metaDataId = metaData?.id;
      ExportParameters(exportforms, metaDataId, Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          if (response.errors) {
            setErrorMsg((prevResponses) => [
              ...prevResponses,
              "Error Creating Process !",
            ]);
            DeleteNewMeta(metaData.id, Cookies.get("newJwt"))
              .then((response) => response?.json())
              .then((response) => {
                setErrorMsg((prevResponses) => [
                  ...prevResponses,
                  "Error Creating Process !",
                ]);
              });
          }
        })
        .catch((error) => {
          setErrorMsg((prevResponses) => [
            ...prevResponses,
            "Error Creating Process !",
          ]);
          DeleteNewMeta(metaData.id, Cookies.get("newJwt"))
            .then((response) => response?.json())
            .then((response) => {
              setErrorMsg((prevResponses) => [
                ...prevResponses,
                "Error Creating Process !",
              ]);
            });
        });
    }
  }, [newParamdata]);

  const handleParamChange = (e, index) => {
    const updatedOptions = [...forms.options];
    updatedOptions[index] = {
      ...updatedOptions[index],
      [e.target.name]: e.target.value,
    };
    setForms({
      ...forms,
      options: updatedOptions,
    });
  };

  useEffect(() => {
    MetaDataList(Cookies.get("newJwt"))
      .then((response) => {
        setMetaList(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [MetaDataList]);

  // useEffect(() => {
  //   getParameterDetails(inputdataSource, Cookies.get("newJwt"))
  //     .then((response) => response?.json())
  //     .then((response) => {
  //       setParamDetails(
  //         response.filter((item) => item.inputDataSource.length > 0)
  //       );
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, [inputdataSource]);

  const selectedClient = Cookies.get("client");
  useEffect(() => {
    FetchDataTypes(
      "InputDataSourceOptions",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response?.json())
      .then((response) => {
        setRequestTypeList(
          response.filter((item) => item.spName === "GetAPIData")
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  function selectedRequestType() {
    forms.map((form) => {
      return setRequestTypeSelected(
        form?.InputDataSource[0]?.ParameterData[0]?.Val
      );
    });
  }
  useEffect(() => {
    const requestType =
      forms?.[0]?.InputDataSource?.[0]?.parameterData?.[0]?.Val;
    //const requestType = "Client"
    if (requestType) {
      FetchDataTypes(
        "InputDataSourceOptionsDetails",
        parseInt(selectedClient),
        Cookies.get("newJwt")
      )
        .then((response) => response?.json())
        .then((response) => {
          setRequestTypeListSelectedItems(
            response.filter((item) => item.requestType === requestType)
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [forms?.[0]?.InputDataSource?.[0]?.parameterData?.[0]?.Val]);

  useEffect(() => {
    const selectedMetaID = forms?.[0]?.InputDataSource?.[0]?.metaDataID;
    if (selectedMetaID) {
      MetaDataDetails(selectedMetaID, Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setGetRequestTypeKey(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [forms?.[0]?.InputDataSource?.[0]?.metaDataID]);

  const [metadataForm, setMetadataForm] = useState(false);
  function showMetadataForm() {
    setMetadataForm((current) => !current);
    if (!metadataForm) {
      setGetEditMetadataID(null);
      setSelectedMetaData(null);
      setSelectedParameter(null);
      setForms([emptyParamData]);
      setExportForms([emptyExportData]);
    }
  }

  function handleChangeClient({ id }) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setMetadataForm(true);
    setGetEditMetadataID(id);
    GetMetaDataByID(id, Cookies.get("newJwt"))
      .then((response) => response?.json())
      .then((response) => {
        setSelectedMetaData(response);
        setData(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (editMetadataID) {
      MetaDataDetails(editMetadataID, Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setSelectedParameter(response);
          setForms(response);
          setAbc(response);
        })
        .catch((error) => {
          console.log(error);
        });

      GetExportParameters(editMetadataID, Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setExportForms(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [editMetadataID]);

  useEffect(() => {
    if (editMetadataID) {
      MetaDataDetails(editMetadataID, Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((data) => {
          setCompareParameterData(data); // Log the parsed JSON data
        })
        .catch((error) => {
          console.log(error);
        });

      GetExportParameters(editMetadataID, Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((data) => {
          setCompareExportParameterData(data); // Log the parsed JSON data
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [editMetadataID]);

  const uniqueSuccessResponses = [...new Set(successMsg)];
  const uniqueErrorResponses = [...new Set(errorMsg)];

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Create Process</h1>
      </div>

      <div className="row w-100 card p-4">
        <div
          className={clsx("alert", "p-2", "px-4", {
            "alert-success": successMsg.length > 0,
            "alert-danger": errorMsg.length > 0,
            "d-block": successMsg.length > 0 || errorMsg.length > 0,
            "d-none": successMsg.length === 0 && errorMsg.length === 0,
          })}
          role="alert"
        >
          {successMsg
            ? uniqueSuccessResponses?.map((response, index) => (
                <li key={index}>{response}</li>
              ))
            : uniqueErrorResponses?.map((response, index) => (
                <li key={index}>{response}</li>
              ))}
          <span
            className="position-absolute cursor-pointer end-0 top-0 my-1"
            onClick={() => setSuccessMsg([])}
          >
            <i className="align-middle me-2 fas fa-fw fa-close"></i>
          </span>
        </div>

        <div className="col-sm-12 p-0">
          <Button
            type="submit"
            className="btn-primary float-end"
            size="btn-xs"
            children={metadataForm ? "Close" : "Add"}
            //showLoading={isBtnLoading}
            onClick={showMetadataForm}
          />
        </div>
        {metadataForm ? (
          <div className="w-100 tradeForm position-relative">
            <Tabs
              selectedIndex={tabIndex}
              onSelect={(index) => setTabIndex(index)}
            >
              <TabList>
                <Tab disabled>Meta Data</Tab>
                <Tab disabled>Parameter Data</Tab>
                {
                  data?.returnType === "dataset" ? <Tab disabled>Export parameter</Tab> : null
                }
                
                {/* <Tab>MetaData List</Tab> */}
              </TabList>

              <TabPanel>
                <form onSubmit={handleSubmitMetaData} className="row g-6 mt-2">
                  <div className="col-md-5 mt-4 d-flex">
                    <label className="col-sm-4 col-form-label">Name:</label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className={clsx(
                          "form-control ",
                          errors.name ? "is-invalid" : null
                        )}
                        name="name"
                        placeholder="Name"
                        onChange={updateData}
                        required
                        defaultValue={selectedMetaData?.name}
                      />
                      {errors.name && (
                        <span classname="formError my-2 w-100 ">
                          {errors.name}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-5 mt-4 d-flex">
                    <label className="col-sm-4 col-form-label">Label:</label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        name="label"
                        placeholder="Label"
                        onChange={updateData}
                        defaultValue={selectedMetaData?.label}
                      />
                    </div>
                  </div>
                  <div className="col-md-5 mt-4 d-flex">
                    <label className="col-sm-4 col-form-label">
                      Description:
                    </label>
                    <div className="col-sm-8">
                      <textarea
                        className="form-control "
                        name="description"
                        placeholder="description"
                        onChange={updateData}
                        defaultValue={selectedMetaData?.description}
                      />
                    </div>
                  </div>
                  <div className="col-md-5 mt-4 d-flex">
                    <label className="col-sm-4 col-form-label">
                      Schema Name:
                    </label>
                    <div className="col-sm-8">
                      {/* <input
                      type="text"
                      className="form-control "
                      name="schemaName"
                      placeholder="SchemaName"
                      defaultValue='dbo'
                      onChange={updateData}
                    /> */}
                      <select
                        className="form-control "
                        name="schemaName"
                        onChange={updateData}
                        value={selectedMetaData?.schemaName}
                        disabled={
                          selectedMetaData?.schemaName !== undefined ?? true
                        }
                      >
                        <option value="">Select</option>
                        <option value="dbo">dbo</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-5 mt-4 d-flex">
                    <label className="col-sm-4 col-form-label">
                      Execution Method:
                    </label>
                    <div className="col-sm-8">
                      {/* <input
                      type="text"
                      className={clsx(
                        "form-control ",
                        errors.executionMethod ? "is-invalid" : null
                      )}
                      name="executionMethod"
                      placeholder="ExecutionMethod"
                      onChange={updateData}
                      //required
                    /> */}
                      <select
                        className={clsx(
                          "form-control ",
                          errors.executionMethod ? "is-invalid" : null
                        )}
                        name="executionMethod"
                        onChange={updateData}
                        required
                        value={selectedMetaData?.executionMethod}
                        disabled={
                          selectedMetaData?.executionMethod !== undefined ??
                          true
                        }
                      >
                        <option value="">Select</option>
                        <option value="sp">SP</option>
                        <option value="api">API</option>
                      </select>
                      {errors?.executionMethod && (
                        <span classname="formError my-2 w-100">
                          {errors?.executionMethod}
                        </span>
                      )}
                      {/* <small className="">Accepted values sp or api</small> */}
                    </div>
                  </div>
                  {data?.executionMethod === "sp" ? (
                    <>
                      <div className="col-md-5 mt-4 d-flex">
                        <label className="col-sm-4 col-form-label">
                          spName:
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className={clsx(
                              "form-control ",
                              errors.spName ? "is-invalid" : null
                            )}
                            name="spName"
                            placeholder="spName"
                            onChange={updateData}
                            defaultValue={selectedMetaData?.spName}
                          />
                          {errors.spName && (
                            <span classname="formError my-2 w-100">
                              {errors.spName}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-5 mt-4 d-flex">
                        <label className="col-sm-4 col-form-label">
                          returnType:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className={clsx(
                              "form-control ",
                              errors.returnType ? "is-invalid" : null
                            )}
                            name="returnType"
                            onChange={updateData}
                            required
                            value={selectedMetaData?.returnType}
                            disabled={
                              selectedMetaData?.returnType !== undefined ?? true
                            }
                          >
                            <option value="">Select</option>
                            <option value="dataprocess">Data Process</option>
                            <option value="dataset">Data Set</option>
                          </select>
                          {errors.returnType && (
                            <span classname="formError my-2 w-100">
                              {errors.returnType}
                            </span>
                          )}
                        </div>
                      </div>
                    </>
                  ) : null}
                  {data?.executionMethod === "api" ? (
                    <>
                      <div className="col-md-5 mt-4 d-flex">
                        <label className="col-sm-4 col-form-label">
                          resourceUrl:
                        </label>
                        <div className="col-sm-8">
                          {/* <input
                    type="text"
                    className={clsx(
                      "form-control ",
                      errors.resourceUrl ? "is-invalid" : null
                    )}
                    name="resourceUrl"
                    placeholder="resourceUrl"
                    onChange={updateData}
                    //required
                  /> */}
                          <select
                            className={clsx(
                              "form-control ",
                              errors.resourceUrl ? "is-invalid" : null
                            )}
                            name="resourceUrl"
                            onChange={updateData}
                            required
                          >
                            <option value="">Select</option>
                            <option value="api">API</option>
                          </select>
                          {/* <small className="">Accepted values API</small> */}
                          {errors.resourceUrl && (
                            <span classname="formError my-2 w-100">
                              {errors.resourceUrl}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-5 mt-4 d-flex">
                        <label className="col-sm-4 col-form-label">
                          httpMethod :
                        </label>
                        <div className="col-sm-8">
                          {/* <input
                    type="text"
                    className={clsx(
                      "form-control ",
                      errors.httpMethod ? "is-invalid" : null
                    )}
                    name="httpMethod"
                    placeholder="httpMethod"
                    onChange={updateData}
                    //required
                  /> */}
                          <select
                            className={clsx(
                              "form-control ",
                              errors.httpMethod ? "is-invalid" : null
                            )}
                            name="httpMethod"
                            onChange={updateData}
                            required
                          >
                            <option value="">Select</option>
                            <option value="api">API</option>
                          </select>
                          {errors.httpMethod && (
                            <span classname="formError my-2 w-100">
                              {errors.httpMethod}
                            </span>
                          )}
                          {/* <small className="">Accepted Method is api</small> */}
                        </div>
                      </div>
                    </>
                  ) : null}

                  <div className="col-md-5 mt-4 d-flex">
                    <label className="col-sm-4 col-form-label">
                      Submit Button Text:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        name="submitButtonText"
                        value={selectedMetaData?.submitButtonText}
                        placeholder="submitButtonText"
                        onChange={updateData}
                      />
                    </div>
                  </div>
                  <div className="col-md-5 mt-4 d-flex">
                    <label className="col-sm-4 col-form-label">
                      Cancel Button Text:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control "
                        name="cancelButtonText"
                        defaultValue={selectedMetaData?.cancelButtonText}
                        placeholder="cancelButtonText"
                        onChange={updateData}
                      />
                    </div>
                  </div>
                  
                    <div className="col-md-5 mt-4 d-flex">
                      <label className="col-sm-4 col-form-label">
                        Allow Execute:
                      </label>
                      <div className="col-sm-8">
                        <select
                          className="form-control "
                          name="allowExecute"
                          onChange={updateData}
                          value={selectedMetaData?.allowExecute}
                          disabled={
                            selectedMetaData?.allowExecute !== undefined ?? true
                          }
                        >
                          <option value="">Select</option>
                          <option value={false}>NO</option>
                          <option value={true}>Yes</option>
                        </select>
                      </div>
                    </div>
                  

                  {data?.allowExecute === true && data?.returnType === "dataset" ? (
                    <>
                      <div className="col-md-5 mt-4 d-flex">
                        <label className="col-sm-4 col-form-label">
                          Allow Excel Export:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control "
                            name="allowExcelExport"
                            onChange={updateData}
                            defaultValue={selectedMetaData?.allowExcelExport}
                          >
                            <option value="">Select</option>
                            <option value={false}>NO</option>
                            <option value={true}>Yes</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-5 mt-4 d-flex">
                        <label className="col-sm-4 col-form-label">
                          Allow Pdf Export:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control "
                            name="allowPdfExport"
                            onChange={updateData}
                            defaultValue={selectedMetaData?.allowPdfExport}
                          >
                            <option value="">Select</option>
                            <option value={false}>NO</option>
                            <option value={true}>Yes</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-5 mt-4 d-flex">
                        <label className="col-sm-4 col-form-label">
                          Allow Csv Export:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control "
                            name="allowCsvExport"
                            onChange={updateData}
                            defaultValue={selectedMetaData?.allowCsvExport}
                          >
                            <option value="">Select</option>
                            <option value={false}>NO</option>
                            <option value={true}>Yes</option>
                          </select>
                        </div>
                      </div>
                    </>
                  ) : null}
                  <div className="col-md-5 mt-4 d-flex">
                    <label className="col-sm-4 col-form-label">Active:</label>
                    <div className="col-sm-8">
                      <select
                        className="form-control "
                        name="active"
                        onChange={updateData}
                        defaultValue={selectedMetaData?.active}
                      >
                        <option value="">Select</option>
                        <option value={false}>NO</option>
                        <option value={true}>Yes</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-12 mb-4">
                    <button
                      type="button"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-link float-start"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-start "
                      onClick={onNext}
                    >
                      Next
                    </button>
                  </div>
                </form>
              </TabPanel>
                <TabPanel>
                <form onSubmit={handleSubmitParaData}>
                  {forms.map((form, index) => (
                    <div
                      key={index}
                      className="d-inline-flex flex-wrap w-100 mb-4 parameterForm"
                    >
                      <h6 className="w-100">
                        Parameter Data {index + 1}
                        {index !== -1 ? (
                          <button
                            className="btn float-end"
                            type="button"
                            onClick={() => removeFormFields(index)}
                          >
                            <i className="align-middle fas fa-trash"></i>
                          </button>
                        ) : null}
                      </h6>

                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">Name:</label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className={clsx(
                              "form-control ",
                              errors.paramname ? "is-invalid" : null
                            )}
                            value={form.name}
                            required
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].name = e.target.value;
                              setForms(newForms);
                            }}
                            defaultValue={form.name}
                          />
                          <div className="invalid-feedback">
                            Please provide a valid name.
                          </div>
                        </div>
                      </div>
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Parameter Type:
                        </label>
                        <div className="col-sm-8">
                          <select
                            type="text"
                            required
                            className={clsx(
                              "form-control ",
                              errors.parameterType ? "is-invalid" : null
                            )}
                            value={form.parameterType}
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].parameterType = e.target.value;
                              setForms(newForms);
                            }}
                          >
                            <option value="">Select</option>
                            <option value="IN">IN</option>
                            <option value="OUT">OUT</option>
                          </select>
                          <div className="invalid-feedback">
                            Please provide a valid Parameter Type.
                          </div>
                        </div>
                      </div>
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          DB Type:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control "
                            name="dbType"
                            required
                            value={form.dbType}
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].dbType = e.target.value;
                              setForms(newForms);
                            }}
                          >
                            <option value="">Select</option>
                            <option value="varchar">varchar</option>
                            <option value="int">int</option>
                            <option value="decimal">decimal</option>
                            <option value="smalldatetime">smalldatetime</option>
                            <option value="datetime">datetime</option>
                            <option value="char">char</option>
                          </select>
                          <div className="invalid-feedback">
                            Please provide a valid dbType.
                          </div>
                        </div>
                      </div>
                      {data?.executionMethod === "api" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Type:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              name="type"
                              value={form.type}
                              required
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].type = e.target.value;
                                setForms(newForms);
                              }}
                            />
                            <small className="">Default value dbo</small>
                          </div>
                        </div>
                      ) : null}

                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Position:
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="number"
                            className="form-control "
                            name="position"
                            placeholder="Position"
                            required
                            value={form.position}
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].position = parseInt(
                                e.target.value
                              );
                              setForms(newForms);
                            }}
                          />
                          {/* <small className="">Accepted values sp or api</small> */}
                        </div>
                      </div>
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          isNullable:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control "
                            name="isNullable"
                            value={form.isNullable}
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].isNullable =
                                e.target.value === "true";
                              setForms(newForms);
                            }}
                          >
                            <option value="">Select</option>
                            <option value={false}>NO</option>
                            <option value={true}>Yes</option>
                          </select>
                          {/* <small className="">Execution Method is sp</small> */}
                        </div>
                      </div>
                      {data?.executionMethod === "sp" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Default Value:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className="form-control "
                              value={form.defaultValue}
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].defaultValue = e.target.value;
                                setForms(newForms);
                              }}
                            />
                            {/* <small className="">Execution Method is api</small> */}
                          </div>
                        </div>
                      ) : null}

                      {data?.executionMethod === "sp" &&
                      form.dbType === "decimal" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Precision:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              className="form-control "
                              value={form.precision}
                              required
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].precision = parseInt(
                                  e.target.value
                                );
                                setForms(newForms);
                              }}
                            />
                          </div>
                        </div>
                      ) : null}

                      {data?.executionMethod === "sp" &&
                      form.dbType === "decimal" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Scale:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              className="form-control "
                              value={form.scale}
                              required
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].scale = parseInt(
                                  e.target.value
                                );
                                setForms(newForms);
                              }}
                            />
                          </div>
                        </div>
                      ) : null}
                      {form.parameterType === "IN" ? (
                        <>
                          <div className="col-md-5 mt-2">
                            <label className="col-sm-4 col-form-label">
                              Label:
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                className="form-control "
                                name="label"
                                placeholder="label"
                                value={form.label}
                                onChange={(e) => {
                                  const newForms = [...forms];
                                  newForms[index].label = e.target.value;
                                  setForms(newForms);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-5 mt-2">
                            <label className="col-sm-4 col-form-label">
                              PlaceHolder:
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                className="form-control "
                                name="placeHolder"
                                placeholder="placeHolder"
                                value={form.placeHolder}
                                onChange={(e) => {
                                  const newForms = [...forms];
                                  newForms[index].placeHolder = e.target.value;
                                  setForms(newForms);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-5 mt-2">
                            <label className="col-sm-4 col-form-label">
                              Tooltip:
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                className="form-control "
                                name="tooltip"
                                placeholder="tooltip"
                                value={form.tooltip}
                                onChange={(e) => {
                                  const newForms = [...forms];
                                  newForms[index].tooltip = e.target.value;
                                  setForms(newForms);
                                }}
                              />
                            </div>
                          </div>
                        </>
                      ) : null}

                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Active:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control "
                            name="active"
                            value={form.active}
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].active =
                                e.target.value === "true";
                              setForms(newForms);
                            }}
                          >
                            <option value="">Select</option>
                            <option value={false}>NO</option>
                            <option value={true}>Yes</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Pattern:
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control "
                            value={form.pattern}
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].pattern = e.target.value;
                              setForms(newForms);
                            }}
                          />
                        </div>
                      </div>
                      {data?.executionMethod === "sp" &&
                      form.dbType === "varchar" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            length:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className="form-control "
                              value={form.length}
                              required
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].length = parseInt(
                                  e.target.value
                                );
                                setForms(newForms);
                              }}
                            />
                          </div>
                        </div>
                      ) : null}
                      {form.parameterType === "IN" ? (
                        <>
                          <div className="col-md-5 mt-2">
                            <label className="col-sm-4 col-form-label">
                              Input Type:
                            </label>
                            <div className="col-sm-8">
                              <select
                                className="form-control "
                                name="inputType"
                                required
                                value={form.inputType}
                                onChange={(e) => {
                                  const newForms = [...forms];
                                  newForms[index].inputType = e.target.value;
                                  setForms(newForms);
                                }}
                              >
                                <option value="">Select</option>
                                <option value="select">Select Options</option>
                                <option value="date">Date</option>
                                <option value="radio">Radio</option>
                                <option value="switch">Switch</option>
                                <option value="number">Number</option>
                                <option value="text">Text</option>
                                <option value="file">File</option>
                                <option value="textarea">Textarea</option>
                                <option value="checkboxgroup">Checkbox</option>
                                <option value="maskedtext">Maskedtext</option>
                              </select>
                            </div>
                          </div>
                        </>
                      ) : null}
                      {form.inputType === "radio" ||
                      form.inputType === "select" ||
                      form.inputType === "checkboxgroup" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Select Type:
                          </label>
                          <div className="col-sm-8 d-flex">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="options"
                                id="flexRadioDefault1"
                                value={form.options}
                                checked={selectType === "options"}
                                onChange={(e) => setSelectType("options")}
                              />
                              <label
                                className="form-check-label"
                                for="flexRadioDefault1"
                              >
                                Options
                              </label>
                            </div>
                            <div className="form-check mx-4">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="inputSelect"
                                id="flexRadioDefault2"
                                value={form.options}
                                checked={selectType === "inputSelect"}
                                onChange={(e) => setSelectType("inputSelect")}
                              />
                              <label
                                className="form-check-label"
                                for="flexRadioDefault2"
                              >
                                InputData Source
                              </label>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {selectType === "inputSelect" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Metadata:
                          </label>
                          <div className="col-sm-8">
                            <select
                              className="form-control "
                              name="metaDataID"
                              value={form.metaDataID}
                              onChange={(e) => {
                                const newForms = [...forms];
                                //newForms[index].InputDataSource[0].metaDataID = e.target.value;
                                newForms[index].InputDataSource[0] = newForms[
                                  index
                                ].InputDataSource[0]
                                  ? {
                                      ...newForms[index].InputDataSource[0],
                                      metaDataID: e.target.value,
                                    }
                                  : {
                                      metaDataID: e.target.value,
                                    };
                                setForms(newForms);
                              }}
                            >
                              <option value="select">Select</option>
                              {metaList &&
                                metaList.map((e, key) => {
                                  return (
                                    <option key={key.id} value={e.id}>
                                      {e.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                      ) : null}
                      {selectType === "inputSelect" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Parameter Value:
                          </label>
                          <div className="col-sm-8">
                            <select
                              className="form-control "
                              name="Val"
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[
                                  index
                                ].InputDataSource[0].parameterData = [
                                  {
                                    Key: "",
                                    Val: e.target.value,
                                  },
                                ];

                                setForms(newForms);
                              }}
                            >
                              <option value="select">Select</option>

                              {requestTypeList &&
                                requestTypeList.map((e, key) => {
                                  return (
                                    <option key={key.id} value={e.id}>
                                      {e.requestType}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                      ) : null}
                      {selectType === "inputSelect" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Parameter Key:
                          </label>
                          <div className="col-sm-8">
                            <select
                              className="form-control "
                              name="Key"
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[
                                  index
                                ].InputDataSource[0].parameterData = [
                                  {
                                    Key: e.target.value,
                                    Val: "",
                                  },
                                ];

                                setForms(newForms);
                              }}
                            >
                              <option value="select">Select</option>

                              {getRequestTypeKey &&
                                getRequestTypeKey.map((e, key) => {
                                  return (
                                    <option key={key.id} value={e.name}>
                                      {e.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                      ) : null}

                      {selectType === "inputSelect" ? (
                        <div className="col-md-5 mt-2 d-flex">
                          <div className="col-sm-5">
                            <label className="col-sm-4 col-form-label">
                              Label:
                            </label>
                            <div className="col-sm-8">
                              <select
                                className="form-control "
                                name="Label"
                                onChange={(e) => {
                                  const newForms = [...forms];
                                  newForms[index].InputDataSource[0].Label =
                                    e.target.value;
                                  setForms(newForms);
                                }}
                              >
                                <option value="select">Select</option>
                                {requestTypeListSelectedItems &&
                                  requestTypeListSelectedItems.map((e, key) => {
                                    return (
                                      <option key={key.id} value={e.options}>
                                        {e.options}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                          </div>
                          <div className="col-sm-5">
                            <label className="col-sm-4 col-form-label">
                              Value:
                            </label>
                            <div className="col-sm-8">
                              <select
                                className="form-control "
                                name="Value"
                                onChange={(e) => {
                                  const newForms = [...forms];
                                  newForms[index].InputDataSource[0].Value =
                                    e.target.value;
                                  setForms(newForms);
                                }}
                              >
                                <option value="select">Select</option>
                                {requestTypeListSelectedItems &&
                                  requestTypeListSelectedItems.map((e, key) => {
                                    return (
                                      <option key={e.id} value={e.options}>
                                        {e.options}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {selectType === "options" ? (
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Options:
                          </label>
                          <div className="col-sm-8">
                            {openInputData ? (
                              <div className="">
                                {optionsList.map((form, i) => {
                                  return (
                                    <div key={i} className="d-flex my-2">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="label"
                                        placeholder="label"
                                        value={form?.options}
                                        required
                                        onChange={(e) => {
                                          var newForms = [...forms];

                                          newForms[index].options[i] = newForms[
                                            index
                                          ].options[i]
                                            ? {
                                                ...newForms[index].options[i],
                                                label: e.target.value,
                                              }
                                            : {
                                                label: e.target.value,
                                                value: "",
                                              };
                                          setForms(newForms);
                                        }}
                                      />
                                      <input
                                        name="value"
                                        type="text"
                                        placeholder="value"
                                        className="form-control mx-2"
                                        value={form.options}
                                        required
                                        onChange={(e) => {
                                          var newForms = [...forms];
                                          newForms[index].options[i] = newForms[
                                            index
                                          ].options[i]
                                            ? {
                                                ...newForms[index].options[i],
                                                value: e.target.value,
                                              }
                                            : {
                                                label: "",
                                                value: e.target.value,
                                              };
                                          setForms(newForms);
                                        }}
                                      />
                                      <button
                                        className="btn"
                                        type="button"
                                        onClick={addOptionsFields}
                                      >
                                        <i className="align-middle fas fa-plus"></i>
                                      </button>

                                      <button
                                        className="btn"
                                        onClick={() => removeFields(index)}
                                      >
                                        <i className="align-middle fas fa-minus"></i>
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ))}

                  <button
                    type="submit"
                    className="btn d-inline-flex align-items-center btn-xs btn btn-link float-start mx-2"
                    onClick={() => setTabIndex(0)}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-start mx-2"
                    onClick={handleAdd}
                  >
                    Add
                  </button>
                  {data?.returnType === "dataprocess" ? (
                    <button
                      type="submit"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end "
                    >
                      Submit
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-start "
                      onClick={onNext}
                    >
                      Next
                    </button>
                  )}
                </form>
              </TabPanel>
              
            {
              data?.returnType === "dataset" ?
              <TabPanel>
                <form onSubmit={handleExportParaData}>
                  <div className="d-flex">
                    <div className="col-md-2 mt-2 mx-1">
                      <label className="form-label">Name</label>
                    </div>
                    <div className="col-md-2 mt-2 mx-1">
                      <label className="form-label">Type</label>
                    </div>
                    <div className="col-md-2 mt-2 mx-1">
                      <label className="form-label">Header Text</label>
                    </div>
                    <div className="col-md-1 mt-2 mx-1">
                      <label className="form-label">Position</label>
                    </div>
                    <div className="col-md-1 mt-2 mx-1">
                      <label className="form-label">Excel Export</label>
                    </div>
                    <div className="col-md-1 mt-2 mx-1">
                      <label className="form-label">PDF Export</label>
                    </div>
                    <div className="col-xs-1 mt-2 mx-1">
                      <label className="form-label">CSV Export</label>
                    </div>
                  </div>
                  {exportforms.map((form, index) => (
                    <div key={index} className="d-inline-flex w-100">
                      <div className="col-md-2 mt-2 mx-1">
                        <div className="col-sm-12">
                          <input
                            type="text"
                            className={clsx(
                              "form-control ",
                              errors.paramname ? "is-invalid" : null
                            )}
                            placeholder="Name"
                            value={form.name}
                            name="name"
                            required
                            onChange={(e) => {
                              const newForms = [...exportforms];
                              newForms[index].name = e.target.value;
                              setExportForms(newForms);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-2 mt-2 mx-1">
                        <div className="col-sm-12">
                          <select
                            className="form-control "
                            name="type"
                            placeholder="Type"
                            required
                            value={form.type}
                            onChange={(e) => {
                              const newForms = [...exportforms];
                              newForms[index].type = e.target.value;
                              setExportForms(newForms);
                            }}
                          >
                            <option value="">Select Type</option>
                            <option value="varchar">varchar</option>
                            <option value="int">int</option>
                            <option value="decimal">decimal</option>
                            <option value="smalldatetime">smalldatetime</option>
                            <option value="datetime">datetime</option>
                            <option value="char">char</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-2 d-flex mt-2 mx-1">
                        <div className="col-sm-12">
                          <input
                            type="text"
                            name="headerText"
                            placeholder="HeaderText"
                            value={form.headerText}
                            className="form-control "
                            //value={form.type}
                            required
                            onChange={(e) => {
                              const newForms = [...exportforms];
                              newForms[index].headerText = e.target.value;
                              setExportForms(newForms);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-1 mt-2 mx-1">
                        <div className="col-sm-12">
                          <input
                            type="number"
                            className="form-control "
                            name="position"
                            placeholder="Position"
                            required
                            value={form.position}
                            onChange={(e) => {
                              const newForms = [...exportforms];
                              newForms[index].position = parseInt(
                                e.target.value
                              );
                              setExportForms(newForms);
                            }}
                          />
                          {/* <small className="">Accepted values sp or api</small> */}
                        </div>
                      </div>
                      <div className="col-md-1 mt-2 mx-1">
                        <div className="col-sm-12">
                          <select
                            className="form-control "
                            name="allowExcelExport"
                            placeholder="Allow Excel Export"
                            value={form.allowExcelExport}
                            onChange={(e) => {
                              const newForms = [...exportforms];
                              newForms[index].allowExcelExport =
                                e.target.value === "true";
                              setExportForms(newForms);
                            }}
                          >
                            <option value="">Allow Excel Export </option>
                            <option value={false}>NO</option>
                            <option value={true}>Yes</option>
                          </select>
                          {/* <small className="">Execution Method is sp</small> */}
                        </div>
                      </div>
                      <div className="col-md-1 mt-2 mx-1">
                        <div className="col-sm-12">
                          <select
                            className="form-control "
                            name="allowPdfExport"
                            placeholder="Allow PDF Export"
                            value={form.allowPdfExport}
                            onChange={(e) => {
                              const newForms = [...exportforms];
                              newForms[index].allowPdfExport =
                                e.target.value === "true";
                              setExportForms(newForms);
                            }}
                          >
                            <option value="">Allow PDF Export </option>
                            <option value={false}>NO</option>
                            <option value={true}>Yes</option>
                          </select>
                          {/* <small className="">Execution Method is sp</small> */}
                        </div>
                      </div>
                      <div className="col-md-1 mt-2 mx-1">
                        <div className="col-sm-12">
                          <select
                            className="form-control "
                            name="allowCsvExport"
                            placeholder="Allow CSV Export"
                            value={form.allowCsvExport}
                            onChange={(e) => {
                              const newForms = [...exportforms];
                              newForms[index].allowCsvExport =
                                e.target.value === "true";
                              setExportForms(newForms);
                            }}
                          >
                            <option value="">Allow CSV Export </option>
                            <option value={false}>NO</option>
                            <option value={true}>Yes</option>
                          </select>
                          {/* <small className="">Execution Method is sp</small> */}
                        </div>
                      </div>
                      <div className=" mt-2 mx-1">
                        {index !== -1 ? (
                          <button
                            className="btn float-end"
                            type="button"
                            onClick={() => removeFormExportFields(index)}
                          >
                            <i className="align-middle fas fa-trash"></i>
                          </button>
                        ) : null}
                      </div>
                    </div>
                  ))}
                  <div className="my-4">
                    <button
                      type="submit"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-link float-start mx-2"
                      onClick={() => setTabIndex(1)}
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-start mx-2"
                      onClick={handleAddExport}
                    >
                      Add
                    </button>
                    <button
                      type="submit"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-start "
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </TabPanel>
              : null
            }
              
              {/* <TabPanel>
              <ProcessList />
            </TabPanel> */}
            </Tabs>
          </div>
        ) : null}
        <hr className="my-4"></hr>
        <ProcessList
          handleChange={handleChangeClient}
          //ref={childRef}
          //refetchMetadataList={refetch}
        />
      </div>
      <ToastContainer />
    </div>
  );
};

export { CreateMetaDataForm };
